import { useState } from 'react';
import { useApi } from '@/hooks/use-connection';
import { cn } from '@/lib/utils';

/** "Yui Hatano" → "YH": what stands in for a photo the source never had. */
export function initials(name: string): string {
  const letters = name
    .split(/\s+/)
    .filter((word) => word.length > 0)
    .map((word) => [...word][0] ?? '')
    .slice(0, 2)
    .join('');
  return letters === '' ? '?' : letters.toUpperCase();
}

/** A round photo of a person, or their initials when there is none or it fails to load. */
export function PersonPhoto(props: { readonly name: string; readonly photo?: string; readonly className?: string }) {
  const api = useApi();
  // Remembers which file failed, so a new photo for the same slot is tried.
  const [failed, setFailed] = useState<string | undefined>(undefined);
  const shown = props.photo !== undefined && failed !== props.photo ? props.photo : undefined;
  return (
    <span className={cn('inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-muted font-medium text-muted-foreground', props.className)}>
      {shown === undefined ? (
        <span className="text-[0.7em]" aria-hidden>
          {initials(props.name)}
        </span>
      ) : (
        <img src={api.assetUrl(shown)} alt="" loading="lazy" decoding="async" onError={() => setFailed(shown)} className="size-full object-cover object-top" />
      )}
    </span>
  );
}
